(function () {
  'use strict';

  window.theme = window.theme || {};
  if (window.theme.componentLoaderBound) return;
  window.theme.componentLoaderBound = true;

  // ============================================================
  // Surface registry
  // ------------------------------------------------------------
  // Replaces three legacy loaders: cart-loader.js, search-loader.js,
  // mobile-menu-loader.js. Adds a fourth surface (overlay) for the
  // overlay primitive (component-overlay.css/js).
  //
  // Per surface contract:
  //   name              — identifier; backs the per-surface loaded flag
  //                       (window.theme.<name>Loaded).
  //   triggerSelector   — CSS selector for delegated click triggers.
  //   pointerGuard      — when true, bail on modifier keys + non-left-click.
  //   bailIf            — optional pre-load predicate.
  //   urlTrigger        — optional location.search substring.
  //   extraTriggerEvent — optional second event binding (e.g. focusin). Single
  //                       {type, selector}; matched with .matches (target IS the
  //                       element). Used by 'search'.
  //   preloadEvents     — optional ARRAY of {type, selector} warm-up bindings,
  //                       matched with .closest (target is a DESCENDANT of the
  //                       zone) and loaded-guarded. Use bubbling events only
  //                       (pointerover, NOT pointerenter). Used by collectionFacets.
  //   assetKeys         — primary [css, js] keys on window.theme.assets. A null
  //                       css key (assetKeys[0]) marks a JS-only surface: the
  //                       primary CSS presence-check + injection are skipped.
  //   secondaryAssetKeys— optional [css, js] pair, chained after primary.
  //   openEvent         — event dispatched after assets load.
  //   externalOpenEvent — event listened for; triggers the same load path.
  //   passTrigger       — when true, openEvent dispatches with detail.trigger.
  // ============================================================
  var surfaces = [
    {
      name: 'cart',
      triggerSelector: '[data-cart-trigger]',
      pointerGuard: true,
      bailIf: function () {
        return (window.theme && window.theme.settings && window.theme.settings.cart_type) === 'page';
      },
      urlTrigger: 'cart_open=1',
      assetKeys: ['cartCss', 'cartJs'],
      secondaryAssetKeys: ['cartBlocksCss', 'cartBlocksJs'],
      openEvent: 'cart:open',
      externalOpenEvent: 'cart:open'
    },
    {
      name: 'search',
      triggerSelector: '[data-search-trigger]',
      extraTriggerEvent: { type: 'focusin', selector: 'input[type="search"]' },
      assetKeys: ['searchCss', 'searchJs'],
      openEvent: 'search:open',
      externalOpenEvent: 'search:open'
    },
    {
      name: 'mobileMenu',
      triggerSelector: '[data-mobile-menu-trigger]',
      pointerGuard: true,
      assetKeys: ['mobileMenuCss', 'mobileMenuJs'],
      openEvent: 'mobile-menu:open',
      externalOpenEvent: 'mobile-menu:open'
    },
    {
      name: 'overlay',
      triggerSelector: '[data-overlay-trigger]',
      assetKeys: ['overlayCss', 'overlayJs'],
      openEvent: 'overlay:open',
      externalOpenEvent: 'overlay:open',
      passTrigger: true
    },
    {
      // Collection facets engine. JS-only surface — the facets CSS is loaded
      // eagerly by sections/main-collection.liquid (it styles facets visible on
      // initial render); the loader handles ONLY the JS, deferring its parse/exec
      // until first filter engagement. assetKeys[0] is null → JS-only path.
      name: 'collectionFacets',
      triggerSelector: '[data-filters-toggle]',        // the Filters BUTTON only — NOT facet links (preventDefault would kill a cold link click)
      preloadEvents: [                                  // warm the engine on hover/focus over the facet area + sort select
        { type: 'pointerover', selector: '[data-collection-facets-zone], [data-collection-sort]' },
        { type: 'focusin',     selector: '[data-collection-facets-zone], [data-collection-sort]' }
      ],
      urlTrigger: 'filter.',                            // a filtered landing page loads the engine eagerly
      assetKeys: [null, 'collectionFacetsJs'],          // JS-only — CSS is eager via the section
      openEvent: 'collection-facets:open',
      passTrigger: true                                 // openEvent carries detail.trigger for the cold-first-open bridge
    }
  ];

  function loadedFlagKey(surface) {
    return surface.name + 'Loaded';
  }

  function dispatchOpenEvent(surface, trigger) {
    if (surface.passTrigger && trigger) {
      document.dispatchEvent(new CustomEvent(surface.openEvent, {
        detail: { trigger: trigger, source: 'click' }
      }));
    } else {
      document.dispatchEvent(new CustomEvent(surface.openEvent));
    }
  }

  function injectStylesheet(href) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function injectScript(src, onLoad) {
    var script = document.createElement('script');
    script.type = 'module';
    script.src = src;
    if (typeof onLoad === 'function') {
      script.onload = onLoad;
    }
    document.head.appendChild(script);
  }

  function loadSurface(surface, trigger) {
    var flag = loadedFlagKey(surface);
    if (window.theme[flag]) {
      dispatchOpenEvent(surface, trigger);
      return;
    }

    var assets = window.theme.assets || {};
    var primaryCss = surface.assetKeys[0];
    var primaryJs = surface.assetKeys[1];
    // JS-only surface: a null/falsy primaryCss means the CSS is loaded elsewhere
    // (e.g. eagerly by the section). Validate only the JS in that case.
    if (!assets[primaryJs] || (primaryCss && !assets[primaryCss])) {
      console.warn('[component-loader] Missing asset URLs for ' + primaryCss + ' / ' + primaryJs);
      return;
    }
    if (surface.secondaryAssetKeys) {
      var secCss = surface.secondaryAssetKeys[0];
      var secJs = surface.secondaryAssetKeys[1];
      if (!assets[secCss] || !assets[secJs]) {
        console.warn('[component-loader] Missing secondary asset URLs for ' + secCss + ' / ' + secJs);
        return;
      }
    }

    window.theme[flag] = true;

    // Inject ALL CSS in parallel up-front (matches legacy cart-loader behavior:
    // both stylesheets begin downloading immediately rather than sequencing
    // the secondary CSS behind the primary JS load). Skipped for JS-only surfaces.
    if (primaryCss) {
      injectStylesheet(assets[primaryCss]);
    }
    if (surface.secondaryAssetKeys) {
      injectStylesheet(assets[surface.secondaryAssetKeys[0]]);
    }

    // Chain JS: primary first, secondary after primary's onload.
    injectScript(assets[primaryJs], function () {
      if (surface.secondaryAssetKeys) {
        injectScript(assets[surface.secondaryAssetKeys[1]], function () {
          dispatchOpenEvent(surface, trigger);
        });
      } else {
        dispatchOpenEvent(surface, trigger);
      }
    });
  }

  function handleClick(event) {
    if (!event.target || !event.target.closest) return;
    // Each surface evaluates independently (matches the legacy three-loader
    // behavior where each loader bound its own click handler). A trigger
    // element matching multiple surface selectors fires all matching
    // surfaces; preventDefault is idempotent.
    for (var i = 0; i < surfaces.length; i++) {
      var surface = surfaces[i];
      var trigger = event.target.closest(surface.triggerSelector);
      if (!trigger) continue;
      if (surface.pointerGuard) {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) continue;
      }
      if (surface.bailIf && surface.bailIf()) continue;
      event.preventDefault();
      loadSurface(surface, trigger);
    }
  }

  function makeExtraTriggerHandler(surface) {
    return function (event) {
      if (!event.target || !event.target.matches) return;
      if (event.target.matches(surface.extraTriggerEvent.selector)) {
        loadSurface(surface, event.target);
      }
    };
  }

  // Separate from makeExtraTriggerHandler: preload events fire on DESCENDANTS of
  // a zone (facet input/link/select), never the zone element itself, so this
  // matches with .closest (not .matches). It also early-returns once the surface
  // is loaded — pointerover fires continuously as the pointer moves over child
  // nodes, so without the guard it would spam loadSurface/dispatchOpenEvent.
  function makePreloadHandler(surface, evt) {
    return function (event) {
      if (window.theme[loadedFlagKey(surface)]) return;
      if (!event.target || !event.target.closest) return;
      if (event.target.closest(evt.selector)) {
        loadSurface(surface, event.target);
      }
    };
  }

  function makeExternalOpenHandler(surface) {
    return function () {
      if (window.theme[loadedFlagKey(surface)]) return;
      if (surface.bailIf && surface.bailIf()) return;
      loadSurface(surface, null);
    };
  }

  function handleURLTriggers() {
    var search = window.location.search || '';
    for (var i = 0; i < surfaces.length; i++) {
      var surface = surfaces[i];
      if (!surface.urlTrigger) continue;
      if (search.indexOf(surface.urlTrigger) === -1) continue;
      if (surface.bailIf && surface.bailIf()) continue;
      loadSurface(surface, null);
    }
  }

  function bind() {
    document.addEventListener('click', handleClick);

    for (var i = 0; i < surfaces.length; i++) {
      var surface = surfaces[i];
      if (surface.extraTriggerEvent) {
        document.addEventListener(surface.extraTriggerEvent.type, makeExtraTriggerHandler(surface));
      }
      if (surface.preloadEvents) {
        for (var p = 0; p < surface.preloadEvents.length; p++) {
          var evt = surface.preloadEvents[p];
          document.addEventListener(evt.type, makePreloadHandler(surface, evt));
        }
      }
      if (surface.externalOpenEvent) {
        document.addEventListener(surface.externalOpenEvent, makeExternalOpenHandler(surface));
      }
    }

    handleURLTriggers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
